var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg074Save(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 21H20C20.5523 21 21 20.5523 21 20V8.99997C21.0015 8.73417 20.8972 8.47869 20.71 8.28997L15.71 3.28997C15.5213 3.10279 15.2658 2.99844 15 2.99997H4C3.44772 2.99997 3 3.44769 3 3.99997V20C3 20.5523 3.44772 21 4 21ZM14 19H10V14H14V19ZM5 4.99997H14.59L19 9.40997V19H16V13C16 12.4477 15.5523 12 15 12H9C8.44772 12 8 12.4477 8 13V19H5V4.99997Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg074Save);
export default __webpack_public_path__ + "static/media/074-save.cc3d650d804fc80acff6bd8a8f103d45.svg";
export { ForwardRef as ReactComponent };